export const i18nChat = {
  title: 'Asistente',
  bot: 'Bot',
  user: 'Usted:',
  send: 'Enviar',
  typing: 'Escribiendo...',
  close: 'Cerrar',
  placeholder: 'Pregunta algo',
  beta: 'Beta',
  help_title: '¿Cómo puedo ayudarte?',
  chat_suggestions: {
    cases: '¿Cuáles son mis casos abiertos?',
    new_case: '¿Cómo crear un caso?',
    asset: 'Más detalles sobre un activo específico',
  },
  thinking: 'Pensando, espera un momento',
  messages: {
    error: 'Lo siento, ocurrió un error. Por favor, intenta de nuevo.',
    timeout:
      'Actualmente tengo dificultades para completar esta solicitud debido a limitaciones técnicas causadas por el volumen o la complejidad de los datos. Podrías obtener mejores resultados si reformulas tu pregunta de una manera más específica o enfocada. ¡Estoy aquí para ayudarte!',
  },
  chat_history: {
    title: 'Historial de chat',
    today: 'Hoy',
    older: 'Anteriores',
    start_new_chat: 'Iniciar nuevo chat',
    session: 'Sesión',
    delete_title: '¿Está seguro de que desea eliminar este chat?',
    delete_info:
      'Esta acción provocará que se pierda información. ¿Está seguro de que desea continuar?',
    delete_cancel: 'Cancelar',
    delete_confirm: 'Sí, eliminar',
  },
};
